import emailjs from '@emailjs/browser';
import type { ContactLead } from './contactService';

const serviceId = import.meta.env.VITE_EMAILJS_SERVICE_ID;
const templateId = import.meta.env.VITE_EMAILJS_TEMPLATE_ID;
const publicKey = import.meta.env.VITE_EMAILJS_PUBLIC_KEY;

export async function sendContactEmail(data: ContactLead) {
  if (!serviceId || !templateId || !publicKey) {
    throw new Error('Email service is not configured. Please try again later.');
  }

  const templateParams = {
    from_name: data.name,
    reply_to: data.email,
    phone: data.phone ?? 'N/A',
    company: data.company ?? 'N/A',
    service: data.service,
    message: data.message,
    to_email: 'info@kandeepaicloud.com',
  };

  const response = await emailjs.send(serviceId, templateId, templateParams, { publicKey });

  if (response.status !== 200) {
    throw new Error('Unable to send email notification right now.');
  }
}

